

import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useI18n } from "@/i18n";
import { useDownload } from "@/hooks/useDownload";
import { useEffect } from "react";
import { AiFillApple } from "react-icons/ai";

const Hero = () => {
    const { language } = useI18n();
    const { isLoading, downloadLatest, latestVersion, getVersionInfo } = useDownload();

    // 组件加载时获取版本信息
    useEffect(() => {
        getVersionInfo();
    }, [getVersionInfo]);

    return (
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
            <div className="container relative z-10 mx-auto px-4 py-20">
                <div className="max-w-6xl mx-auto">
                    <div className="text-center mb-12 animate-in fade-in slide-in-from-bottom-4 duration-1000">
                        <h1 className="text-5xl md:text-7xl font-bold mb-6 text-gray-900">

                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 12,
                                marginBottom: 20,
                            }}>
                                <div style={{
                                    display: "inline-block",
                                    backgroundImage: `url(/estha-icon.png)`,
                                    backgroundSize: "contain",
                                    width: 30,
                                    height: 30,
                                }}/>
                                <div style={{
                                    fontSize: 24
                                }}>
                                    Estha
                                </div>
                            </div>
                            {language === 'en' ? (
                                <>
                                    Run AI locally.<br/>Privately. Fast.</>
                            ) : (
                                <>本地运行AI<br/>私密、快速</>
                            )}
                        </h1>
                        <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto text-balance">
                            {language === 'en'
                                ? 'Estha for macOS — Build and run AI apps without the cloud. Everything stays on your Mac.'
                                : <>Estha for macOS — 无需云端即可构建和运行AI应用。<br/>一切都在您的Mac上。</>
                            }
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                            <Button
                                size="lg"
                                className="text-lg px-8"
                                onClick={downloadLatest}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <Loader2 className="mr-2 animate-spin"/>
                                        {language === 'en' ? 'Loading...' : '加载中...'}
                                    </>
                                ) : (
                                    <>
                                        <AiFillApple className="mr-2"/>
                                        {language === 'en' ? `Download Estha for macOS ${latestVersion?.version || ''}` : `下载 Estha macOS 版 ${latestVersion?.version || ''}`}
                                    </>
                                )}
                            </Button>
                            <Button
                                size="lg"
                                variant="outline"
                                className="text-lg px-8"
                                onClick={() => document.getElementById('apps')?.scrollIntoView({behavior: 'smooth'})}
                            >
                                {language === 'en' ? 'Browse Apps' : '浏览应用'}
                            </Button>
                        </div>


                        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-6 text-gray-600">
                            {language === 'en' ?
                                "⚡ Requires: Apple M4/M5 chip · 32GB RAM minimum"
                                :
                                "⚡ 系统要求：Apple M4/M5 芯片 · 至少 32GB 内存"}
                        </div>
                    </div>

                    <div className="mt-16 animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-300">
                        <div className="relative rounded-2xl overflow-hidden shadow-xl">
                            <img
                                src="/hero-macbook.jpg"
                                alt="Estha AI running on MacBook Pro"
                                className="w-full h-auto"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
